import type { IconNode } from '../types';

/**
 * @name shorts
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMiA4aDIwIiAvPgogIDxwYXRoIGQ9Ik05IDIwSDRhMiAyIDAgMCAxLTItMlY1YzAtLjYuNC0xIDEtMWgxOGMuNiAwIDEgLjQgMSAxdjEzYTIgMiAwIDAgMS0yIDJoLTVsLTMtNVoiIC8+CiAgPHBhdGggZD0iTTkgMTJWOCIgLz4KICA8cGF0aCBkPSJNMTUgOHY0IiAvPgogIDxwYXRoIGQ9Im01IDEzLTMgMiIgLz4KICA8cGF0aCBkPSJtMjIgMTUtMy0yIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/shorts
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const shorts: IconNode = [
  ['path', { d: 'M2 8h20', key: 'd11cs7' }],
  [
    'path',
    {
      d: 'M9 20H4a2 2 0 0 1-2-2V5c0-.6.4-1 1-1h18c.6 0 1 .4 1 1v13a2 2 0 0 1-2 2h-5l-3-5Z',
      key: '17og06',
    },
  ],
  ['path', { d: 'M9 12V8', key: '2l2gzn' }],
  ['path', { d: 'M15 8v4', key: '1tfguq' }],
  ['path', { d: 'm5 13-3 2', key: '1pooxw' }],
  ['path', { d: 'm22 15-3-2', key: 'jeffwy' }],
];

export default shorts;
